<aside class="cd-sidebar" aria-label="Counselor navigation">
  <div class="cd-logo-wrapper">
    <img src="assets/logos/SVG/Handle_Horz_Logo_White.svg" alt="Handle" class="app-logo-img" />
  </div>

  <nav aria-label="Main menu">
    <mat-nav-list class="cd-nav">
      <a
        mat-list-item
        class="cd-nav-item active"
        routerLink="/counselors"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
        aria-label="Dashboard"
      >
        <mat-icon matListItemIcon aria-hidden="true">dashboard</mat-icon>
        <span matListItemTitle>Dashboard</span>
      </a>

      <a
        *hasPermission="permissions.POSTS.VIEW"
        mat-list-item
        class="cd-nav-item"
        routerLink="/counselors/posts"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
        aria-label="My Posts"
      >
        <mat-icon matListItemIcon aria-hidden="true">article</mat-icon>
        <span matListItemTitle>My Posts</span>
      </a>

      <a
        *hasPermission="permissions.STUDENTS.VIEW_ASSIGNED"
        mat-list-item
        class="cd-nav-item"
        routerLink="/counselors/students"
        routerLinkActive="active"
        aria-label="My Students"
      >
        <mat-icon matListItemIcon aria-hidden="true">groups</mat-icon>
        <span matListItemTitle>My Students</span>
      </a>

      <a
        *hasPermission="permissions.MESSAGING.VIEW"
        mat-list-item
        class="cd-nav-item"
        routerLink="/counselors/messages"
        routerLinkActive="active"
        aria-label="Messages"
      >
        <mat-icon matListItemIcon aria-hidden="true">messages</mat-icon>
        <span matListItemTitle>Messages</span>
      </a>

      <a
        *hasPermission="permissions.CALENDAR.VIEW"
        mat-list-item
        class="cd-nav-item"
        routerLink="/counselors/calendar"
        routerLinkActive="active"
        aria-label="Calendar"
      >
        <mat-icon matListItemIcon aria-hidden="true">calendar_month</mat-icon>
        <span matListItemTitle>Calendar</span>
      </a>

      <a
        *hasPermission="permissions.CAREER.VIEW"
        mat-list-item
        class="cd-nav-item"
        routerLink="/counselors/careers"
        routerLinkActive="active"
        aria-label="Careers"
      >
        <mat-icon matListItemIcon aria-hidden="true">work</mat-icon>
        <span matListItemTitle>Careers</span>
      </a>

      <a
        *hasPermission="[permissions.MODERATION.VIEW_REPORTED, permissions.MODERATION.MANAGE_TERMS]"
        mat-list-item
        class="cd-nav-item"
        routerLink="/counselors/moderation"
        routerLinkActive="active"
        aria-label="Moderation"
        data-testid="moderation-nav-item"
      >
        <mat-icon matListItemIcon aria-hidden="true">shield</mat-icon>
        <span matListItemTitle>Moderation</span>
      </a>

      <a
        *hasPermission="permissions.USERS.VIEW"
        mat-list-item
        class="cd-nav-item"
        routerLink="/counselors/users"
        routerLinkActive="active"
        aria-label="User Management"
      >
        <mat-icon matListItemIcon aria-hidden="true">manage_accounts</mat-icon>
        <span matListItemTitle>User Management</span>
      </a>

      <a
        *hasPermission="permissions.ANALYTICS.VIEW"
        mat-list-item
        class="cd-nav-item"
        routerLink="/counselors/insights"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
        aria-label="Insights and Analytics"
        data-testid="insights-nav-item"
      >
        <mat-icon matListItemIcon aria-hidden="true">insights</mat-icon>
        <span matListItemTitle>Insights &amp; Analytics</span>
      </a>

      <a
        *hasPermission="permissions.AUDIT.VIEW_LOGS"
        mat-list-item
        class="cd-nav-item"
        routerLink="/audit-logs"
        routerLinkActive="active"
        aria-label="Audit Logs"
      >
        <mat-icon matListItemIcon aria-hidden="true">policy</mat-icon>
        <span matListItemTitle>Audit Logs</span>
      </a>

      <a
        *hasPermission="permissions.MEETINGS.VIEW"
        mat-list-item
        class="cd-nav-item"
        routerLink="/counselors/meetings"
        routerLinkActive="active"
        aria-label="Meetings"
        data-testid="meetings-nav-item"
      >
        <mat-icon matListItemIcon aria-hidden="true">perm_contact_calendar</mat-icon>
        <span matListItemTitle>Meetings</span>
      </a>

      <a
        *hasPermission="permissions.REPORTS.VIEW"
        mat-list-item
        class="cd-nav-item"
        routerLink="/counselors/reports"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
        aria-label="Reports"
        data-testid="counselor-reports-nav-item"
      >
        <mat-icon matListItemIcon aria-hidden="true">outbox</mat-icon>
        <span matListItemTitle>Reports</span>
      </a>

      <a
        mat-list-item
        class="cd-nav-item"
        routerLink="/privacy"
        routerLinkActive="active"
        aria-label="Privacy Agreement"
      >
        <mat-icon matListItemIcon aria-hidden="true">description</mat-icon>
        <span matListItemTitle>Privacy Agreement</span>
      </a>
    </mat-nav-list>
  </nav>

  <div class="cd-user" aria-label="Logged in user">
    <button
      type="button"
      class="cd-user-identity"
      [matMenuTriggerFor]="userMenu"
      aria-label="Open account menu"
      aria-haspopup="true"
    >
      <div class="cd-user-avatar" aria-hidden="true">
        {{ ((user$ | async)?.preferredName || (user$ | async)?.firstName)?.[0]
        }}{{ (user$ | async)?.lastName?.[0] }}
      </div>
      <div>
        <div class="cd-user-name">
          {{
            `${(user$ | async)?.preferredName || (user$ | async)?.firstName} ${(user$ | async)?.lastName}`
          }}
        </div>
        <div class="cd-user-school">Waltham High School</div>
      </div>
    </button>

    <mat-menu #userMenu="matMenu" class="counselor-nav-account-menu" xPosition="after">
      <a
        *hasPermission="permissions.PROFILE.EDIT_OWN"
        mat-menu-item
        routerLink="/profilePage"
        aria-label="Open my profile"
        data-testid="faculty-profile-link"
      >
        <mat-icon aria-hidden="true">person</mat-icon>
        <span>My Profile</span>
      </a>
      <button
        mat-menu-item
        (click)="logout()"
        class="danger"
        aria-label="Log out"
        data-testid="logout-button"
      >
        <mat-icon aria-hidden="true">logout</mat-icon>
        <span>Log Out</span>
      </button>
    </mat-menu>

    <!-- Alerts sits here rather than in the nav list above: it opens a panel
         instead of navigating, so it doesn't belong among the destinations. -->
    <app-alerts-menu #alerts [origin]="alertsTrigger" />

    <button
      type="button"
      class="cd-user-alerts"
      cdkOverlayOrigin
      #alertsTrigger="cdkOverlayOrigin"
      (click)="alerts.toggle()"
      aria-label="Alerts and notifications"
    >
      @let alertCount = (alertsService.unreadCount$ | async) ?? 0;
      <mat-icon
        aria-hidden="true"
        [matBadge]="alertCount"
        [matBadgeHidden]="alertCount === 0"
        matBadgeColor="warn"
      >
        notifications_none
      </mat-icon>
    </button>
  </div>
</aside>
